import script from "./VibeCodePromotionTerminal.vue?vue&type=script&setup=true&lang=js"
export * from "./VibeCodePromotionTerminal.vue?vue&type=script&setup=true&lang=js"

import "./VibeCodePromotionTerminal.vue?vue&type=style&index=0&id=6204d554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6204d554"]])

export default __exports__